import React, { useState } from 'react'
import { Row, Col } from 'antd'
import BannerAbout from '@/assets/images/about/banner.jpeg'


const Banner: React.FC = () => {
  return (
    <>
      <Row gutter={10} className='warp-about-banner'>
        <Col md={24}>
          <img width={'100%'} src={BannerAbout} alt=""/>
        </Col>
      </Row>
    </>
  )
}
export default Banner